import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { Modal, Overlay, ScrollArea } from '@mantine/core';

import { useEditProphetRule } from '../../api/editRule';
import { prophetTypes } from '../../types';
import { ChunkPlatform } from '../../utils/chunk-limits';

import { RuleForm } from './RuleForm/RuleForm';

export const EditModal = NiceModal.create(
  ({
    appPageId,
    rule,
    platform,
  }: {
    appPageId: string;
    rule: prophetTypes.Rule;
    platform: ChunkPlatform;
  }) => {
    const modal = useModal();

    const editProphetRule = useEditProphetRule({
      pageId: rule.page._id,
      config: { onSuccess: modal.hide },
    });

    return (
      <Modal
        title={rule.keyword || 'Стандартное правило'}
        centered
        overlayProps={{ opacity: 0.4, blur: 1.5 }}
        opened={modal.visible}
        onClose={modal.remove}
        closeOnEscape={!editProphetRule.isLoading}
        closeOnClickOutside={!editProphetRule.isLoading}
        withCloseButton={!editProphetRule.isLoading}
        scrollAreaComponent={ScrollArea.Autosize}
      >
        {editProphetRule.isLoading && <Overlay opacity={0} />}
        <RuleForm
          onSubmit={(data) => editProphetRule.mutate({ ...data, _id: rule._id })}
          appPageId={appPageId}
          isLoading={editProphetRule.isLoading}
          isKeywordInputDisabled={!rule.keyword}
          platform={platform}
          initialValues={{
            actions: rule.actions,
            keyword: rule.keyword,
            requirements: rule.requirements,
            messages: rule.messages,
            intervals: rule.intervals,
            isDiscountRequired: rule.isDiscountRequired,
            isSpreadKickRequired: rule.isSpreadKickRequired,
          }}
        />
      </Modal>
    );
  }
);
